import { Component, AfterViewInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { IOcbEnvironmentAccess } from '@app/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-environment-picker',
    templateUrl: './environment-picker.component.html',
    styleUrls: ['./environment-picker.component.scss'],
})
export class EnvironmentPickerComponent implements AfterViewInit {

    @Input()
    public environments: IOcbEnvironmentAccess[];

    @Input()
    public isRequired: boolean = false;

    @Input()
    public selectedItem: IOcbEnvironmentAccess;

    @Output()
    public selectedItemChange = new EventEmitter<IOcbEnvironmentAccess>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public ngAfterViewInit(): void {
        if (this.selectedItem) this.selectBox.value = this.selectedItem.environmentId;
    }

    public onSelectedItemChange($event: IOcbEnvironmentAccess): void {
        if ($event == null) return;
        this.selectedItemChange.emit($event);
    }
}
